
	import {
		Component,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import {
		pca
	} from '@/utils/pca';

	@Component({
		name: 'address-select',
	})
	export default class AddressSelect extends Vue {
		@Prop({
			default: []
		}) value!: any;
		@Prop({
			default: false
		}) private showCounty!: false;
		@Prop({
			default: false
		}) private disabled: false;
		private province = '';
		private city = '';
		private county = '';
		private provincelist = [];
		private citylist = [];
		private countylist = []
		private first = true

		@Watch('value')
		private onChangeValue(val: any) {
			if (this.value.length) {
				this.changeaddress()
			}
		}

		private mounted() {
			// console.log(this.value,33)
			this.getProvinceList()
			setTimeout(()=>{
				this.changeaddress()
			},100)
		}

		private changeaddress(){
			let value = JSON.parse(JSON.stringify(this.value))
			this.province = value[0]
			this.city = value[1]
			this.county = value[2] ? value[2] : ''
			if(!this.first) return
			if(this.city){
				this.getCity()
			}
			if(this.county){
				this.getCounty()
			}
			this.first = false
		}

		// 获取省份列表
		private getProvinceList() {
			this.provincelist = []
			for (let a in pca) {
				for (let p in pca[a]) {
					this.provincelist.push({
						area: a,
						province: p,
						citys: pca[a][p]
					})
				}
			}
		}

		// 获取城市列表
		private getCity() {
			this.citylist = [];
			for (let i = 0; i < this.provincelist.length; i++) {
				if (this.provincelist[i].province === this.province) {
					let citys: any = this.provincelist[i].citys;
					for (let j in citys) {
						this.citylist.push({
							province: this.province,
							city: j,
							county: citys[j]
						})
					}
					// this.city = this.citylist[0].city;
					if (this.showCounty && this.city) {
						this.getCounty()
					} else {
						this.$emit('change', [this.province, this.city])
					}
					break;
				}
			}
		}

		// 获取地区列表
		private getCounty() {
			this.citylist.map((item: any) => {
				if (item.city === this.city) {
					this.countylist = item.county;
					// this.county = item.county[0];
					this.$emit('change', [this.province, this.city, this.county])
				}
			})
		}

		// 修改
		private handleChange(event: any, type: string) {
			// console.log(type)
			if (type === 'city' && this.showCounty) {
				// console.log(this.city,event)
				this.county = ''
				this.getCounty()
				this.$emit('change', [this.province, this.city, this.county])
			}else if (type === 'county') {
				// this.city = ''
				this.$emit('change', [this.province, this.city, this.county])
			} else if (type === 'province')  {
				// console.log(1)
				this.city = ''
				this.county = ''
				this.countylist = []
				this.getCity()
				// this.$emit('change', [this.province, this.city])
				this.$emit('change', [this.province, this.city, this.county])
			}
		}
	}
